import styled, { css } from 'styled-components';
import RadioGroupOriginal from 'components/RadioGroup';
import {
	black,
	chartDarkGray,
	waterfallChartExportColors,
	grey150,
	grey100,
	grey400,
} from 'styles/colors';
import { Wrapper as ContextualWrapper } from '../ContextualMenu/ContextualMenu.styles';

const threeColsWidthStyle = css`
	width: calc(33% - 24px);
`;

export const SpendCategorizationColumn = styled.ul`
	${threeColsWidthStyle};
`;

export const SpendCategorizationContainerBkp = styled.ul`
	position: relative;
	font-family: Roboto;
	columns: ${({ columnsCount }) => (columnsCount ? columnsCount : 'auto')};
	column-gap: 36px;
	margin-top: -4px;
	padding: 0 0 20px 0;
	height: ${({ columnsCount }) => (columnsCount === 1 ? 'auto' : '720px')};

	& > & li {
		margin-top: 16px;
	}
`;

export const SpendCategorizationChartContainer = styled.div`
	margin: -50px 0 -20px 0;
	width: ${props => (props.width ? `${props.width}px` : '')};
	height: ${({ height }) => (height ? `${height}px` : 'auto')};
	padding-bottom: ${({ singleColumn }) => (singleColumn ? '18px' : 'auto')};
`;

export const CategoryName = styled.span`
	color: ${black};
	font-weight: bold;
	letter-spacing: 0.3px;
	line-height: 24px;
	margin-right: 20px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: inline-block;
	flex-grow: 1;
`;

export const ValueCell = styled(CategoryName)`
	text-transform: uppercase;
	text-align: right;
	margin-right: 0;
	width: 18%;
	max-width: 18%;
	min-width: 18%;
	overflow: visible;
	display: inline-flex;
	flex-flow: row-reverse;
`;

export const NegativeValueCell = styled(ValueCell)`
	color: ${grey400};
`;

export const SubCategoriesList = styled.ul`
	padding-top: 10px;
`;

export const SubCategoryName = styled(CategoryName)`
	font-weight: normal;
	font-size: 13px;
	letter-spacing: 0.8px;
	line-height: 19px;
`;

export const SubCategoryValue = styled(SubCategoryName)`
	position: absolute;
	right: 2px;
`;

export const SubCategory = styled.li`
	height: 21px;
	padding-top: 0px;
	position: relative;
	display: flex;

	${ValueCell}, ${NegativeValueCell} {
		margin-right: 0;
		font-weight: 500;
		width: auto;
		text-transform: uppercase;
	}

	${ContextualWrapper} {
		display: none;
		left: -36px;
		top: -8px;
	}

	${({ active }) =>
		active &&
		css`
			${ContextualWrapper} {
				display: block;
			}
		`};

	${({ hasOnClick }) =>
		hasOnClick &&
		css`
			&:hover {
				${ContextualWrapper} {
					display: block;
				}
			}
		`};
`;

export const BarChartProgressBackground = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	height: ${({ height }) => `${height}px` || '8px'};
	background-color: ${grey150};
`;

export const BarChartProgressWrapper = styled.div`
	position: relative;
	height: ${({ height }) => `${height}px` || '8px'};

	& svg {
		position: absolute;
		top: 0;
	}
`;

export const NegativeBarChartProgressWrapper = styled(BarChartProgressWrapper)`
	margin-top: 0;
`;

export const CategoryNameWrapper = styled.div`
	display: flex;

	${ContextualWrapper} {
		display: none;
		padding-top: 2px;
		left: -36px;
		top: -8px;
	}

	${({ active }) =>
		active &&
		css`
			${ContextualWrapper} {
				display: block;
			}
		`};

	${({ hasOnClick }) =>
		hasOnClick &&
		css`
			&:hover {
				${ContextualWrapper} {
					display: block;
				}
			}
		`};
`;

export const ValuesTitlesHeader = styled(CategoryNameWrapper)`
	margin-bottom: -8px;

	${ValueCell} {
		color: ${chartDarkGray};
		font-size: 11px;
		letter-spacing: 0;
		line-height: 13px;
		text-align: right;
		text-transform: none;
		font-weight: normal;
	}
`;

export const CategoryItemContainer = styled.li`
	font-size: 16px;
	max-width: 100%;
	margin-top: 16px;
	width: 100%;
	position: relative;

	${({ onClick }) =>
		onClick
			? `
					cursor: pointer;
				`
			: ``};
`;

export const BlankCategoryItemContainer = styled(CategoryItemContainer)`
	margin-top: 8px;
`;

export const SpendCategorizationContainer = styled.div`
	justify-content: space-between;

	font-family: Roboto;
	margin-top: 16px;
	padding: 0 0 20px 0;
	${({ columnsCount }) =>
		columnsCount === 1
			? css`
					display: block;

					${SpendCategorizationColumn} {
						width: 100%;
					}
			  `
			: columnsCount === 2
				? css`
						display: flex;
						${SpendCategorizationColumn} {
							width: calc(50% - 25px);
						}
				  `
				: css`
						display: flex;
				  `};

	& > & li {
		margin-top: 16px;
	}
`;

export const TotalSpendCategorizationContainer = styled(
	SpendCategorizationContainer
)`
	padding: 0;
	margin-top: 0;
	height: auto;
	flex-direction: column;
	padding-top: 53px;
	width: 100%;

	& ${CategoryItemContainer} {
		font-size: 16px;
		display: inline-block;
	}

	& ${CategoryName} {
		font-size: 19px;
	}

	& ${ValueCell} {
		font-size: 16px;
	}

	& ${CategoryNameWrapper} {
		margin-bottom: 9px;
	}

	& ${ValuesTitlesHeader} {
		margin-bottom: -8px;
		& ${ValueCell} {
			font-size: 11px;
			text-transform: uppercase;
		}
	}
`;

export const BlankCategoryItem = styled(CategoryItemContainer)`
	height: 0px;
	margin-top: 0px;
`;

export const LevelsLabel = styled.div`
	line-height: 44px;
	text-transform: uppercase;
	color: ${chartDarkGray};
`;

export const LevelsToggleContainer = styled.div`
	display: flex;
	position: relative;
	color: ${black};
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0.8px;
	min-height: 48px;

	& > div {
		display: flex;
		flex-direction: row;
	}
`;

export const RadioGroup = styled(RadioGroupOriginal)`
	& > div > div {
		padding-right: 7px;
		padding-left: 7px;
	}
`;

export const TotalBlock = styled.div`
	display: none;
	margin: 10px auto 40px;
	text-align: center;
	color: white;
	font-weight: bold;
	background: ${waterfallChartExportColors.blue};
	padding: 12px 8px 8px 8px;
	font-size: 22px;
	line-height: 24px;
	${threeColsWidthStyle};
`;

export const TotalName = styled.div``;

export const TotalValue = styled.div``;

const PptChartExportOverrides = css`
	${TotalSpendCategorizationContainer} {
		display: none;
		margin-top: -4px;
	}

	${TotalBlock} {
		display: block;
	}

	${CategoryItemContainer} {
		&:first-child {
			margin-top: 0;
		}
	}

	font-family: Verdana;
`;

export const SpendCategorizationChartContainerWithExport = styled(
	SpendCategorizationChartContainer
)`
	background: white;
	margin: 0;

	${SubCategory} {
		height: 26px;
	}

	${SubCategoryName} {
		font-size: 16px;
		line-height: 22px;
	}

	${CategoryName} {
		font-size: 16px;
		height: 38px;
		line-height: 38px;
	}

	${TotalSpendCategorizationContainer} {
		${CategoryItemContainer} {
			margin-top: 14px;
		}
	}

	${BarChartProgressWrapper} + ${BarChartProgressWrapper} {
		margin-bottom: 2px;
	}

	${({ isPptExport }) => (isPptExport ? PptChartExportOverrides : '')};

	${BarChartProgressBackground} {
		background-color: ${grey100};
	}

	${BlankCategoryItemContainer} {
		margin-top: 0;
	}
`;
